import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, input, Input, model, output, ViewChild } from '@angular/core';
import { ElementSize } from '../../types/element-size';
import { UBaseInfraComponent } from '../u-base-infra.component';

//Version 1
export type UButtonType = 'primary' | 'primary-danger' | 'secondary' | 'secondary-danger' | 'secondary-light' | 'tertiary' | 'link';

//Version 2
export type StyleType = 'fill' | 'outlined' | 'text' | 'link';

@Component({
  selector: 'u-button',
  templateUrl: './u-button.component.html',
  styleUrls: ['./u-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UButtonComponent extends UBaseInfraComponent {
  //Version 2
  label = model<string>(null);
  styleType = input<StyleType>('fill');
  fontIcon = input<string>(null);
  iconPos = input<'left' | 'right'>('left');
  contentPos = input<'left' | 'right'>('left');
  forceSecondaryDarkMode = input<boolean>(false);
  versionNumber = input<number>(1);
  styles = input<any>({});

  onClick = output<any>();

  @ViewChild('buttonV2') buttonV2Ref: ElementRef;

  @HostBinding('class.u-host-button-v2')
  get isVersionTwo(): boolean {
    return this.versionNumber() === 2;
  }

  getBaseClasses() {
    return {
      ...super.getBaseClasses(),
      'p-button-outlined': this.styleType() === 'outlined',
      'p-button-text': this.styleType() === 'text',
      'p-button-link': this.styleType() === 'link',
      'p-button-icon-only': this.fontIcon() && !this.label(),
    };
  }

  getIconRef() {
    if (this.versionNumber() > 1) {
      return this.buttonV2Ref?.nativeElement?.querySelector('.p-button-icon');
    }
    return this.button?.nativeElement?.querySelector('.p-button-icon');
  }

  getButtonRef(): ElementRef {
    if (this.versionNumber() > 1) {
      return this.buttonV2Ref;
    }
    return this.button;
  }

  click(event: any) {
    if (['readonly', 'disabled', 'loading'].includes(this.stateElement())) {
      return;
    }
    this.onClick.emit(event);
  }

  //Version 1
  private _active = false;

  @Input() disabled: boolean = false;
  @Input() type: UButtonType = 'primary';
  @Input() withIcon = false;
  @Input() onlyIcon = false;
  @Input() elementSize: ElementSize;
  @Input() loading = false;

  @Input() set active(v: boolean) {
    if (this._active && !v) {
      this.button.nativeElement.blur();
    }
    this._active = v;
  }
  get active() {
    return this._active;
  }

  @ViewChild('button') button: ElementRef;

  @HostBinding('class.u-host-button-v1')
  get isVersionOne(): boolean {
    return this.versionNumber() === 1;
  }
}
